"use client";

import React, { ReactElement } from "react";
import { HXIcon, ImageKit, Typography } from "@aph/ui-lib-humanx";
import { CountSectionInterface } from "@/components/SpecialistCareTeamMobile/SpecialistCareTeamMobileInterface";
import { CareTeamComponent, CareTeamInfoItem } from "@/components/PageHome/api/interface";
import styles from "./SpecialistCareTeamMobile.module.scss";

const CountSection = (props: CountSectionInterface): ReactElement => {
  const { count, bottomText } = props;

  return (
    <Typography component="p" className={styles.list}>
      <span className={styles.numerTxt}>{count}</span>
      {bottomText}
    </Typography>
  );
};

interface SpecialistCareTeamMobileProps {
  data: CareTeamComponent;
}

const SpecialistCareTeamMobile: React.FC<SpecialistCareTeamMobileProps> = ({ data }) => {
  const { Title, NumberText, Icon, Image } = data;

  return (
    <div className={styles.root}>
      <div className={styles.topSection}>
        <div className={styles.logo}>
          <ImageKit src={Icon?.data?.attributes?.url} alt="logo" height={52} width={52} />
        </div>
        {!!Title && (
          <Typography component="h2" className={styles.title}>
            <span dangerouslySetInnerHTML={{ __html: Title }} />
          </Typography>
        )}
        <ImageKit
          src={Image?.data?.attributes?.url}
          alt="banner Image"
          height={322}
          width={269}
          className={styles.imgBx}
        />
        {!!NumberText.length && (
          <div className={styles.extraInfoRoot}>
            {NumberText.map(({ Number, Text, id }: CareTeamInfoItem) => (
              <CountSection key={id} count={Number} bottomText={Text} />
            ))}
          </div>
        )}
      </div>
      {/* background */}
      <div className={styles.bg}>
        <div className={styles.style1}>
          <HXIcon iconPosition="topLeft" backgroundColor="#F9E8D566" />
          <HXIcon iconPosition="topRight" backgroundColor="#F9E8D566" />
        </div>
        <div className={`${styles.style1} ${styles.inlineIcon}`}>
          <HXIcon iconPosition="bottomRight" backgroundColor="#F9E8D566" />
          <HXIcon iconPosition="topLeft" backgroundColor="#F9E8D566" />
          <HXIcon iconPosition="topRight" backgroundColor="#F9E8D566" />
          <HXIcon iconPosition="bottomLeft" backgroundColor="#F9E8D566" />
          <HXIcon iconPosition="bottomRight" backgroundColor="#F9E8D566" />
        </div>
      </div>
    </div>
  );
};

export default SpecialistCareTeamMobile;
